import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input, Row, Col, Container } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

import aside from './img/aside.png'

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
    const { translate } = useLocalization();
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  parameters.idp = 'cableyvideo';

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
      },
      parameters
    )
    .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        let message= translate("RequestLoginErrorMessage");

        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message: message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
        <div className="login-cablevideoimagen-container" ref={nodeRef}>
          <div className="logo-arriba-div"><img src={aside} alt="aside" className="logo-arriba"/></div>
          <Form className="login-form" onSubmit={(event) => onSubmit(event)}>
            <Container fluid={true} className="cablevideoimagen-form-container">
              <h1 className="desc">{translate("ClientAuthentication")}</h1>
              <div className="cablevideoimagen-separator"></div>
              <Row className="cablevideoimagen-form-body">
                <Col sm="12" xs="12" md="12" className="cablevideoimagen-input">
              <div><p className="detail">{translate("PlaceholderUserName")}</p></div>
                  <Input
                    className="user-input-cablevideoimagen"
                    disabled={onLogin}
                    required={true}
                    tabIndex={1}
                    type="text"
                    autoCorrect="off"
                    autoCapitalize="none"
                    id="username"
                    onChange={e => setUsername(e.target.value)}
                    placeholder=""
                  />
                </Col>
                <Col sm="12" xs="12" md="12" className="cablevideoimagen-input">
                <div><p className="detail">{translate("PlaceholderPassword")}</p></div>
                  <Input
                    className="pass-input-cablevideoimagen"
                    required={true}
                    disabled={onLogin}
                    tabIndex={1}
                    type="password"
                    autoCorrect="off"
                    autoCapitalize="none"
                    id="password"
                    placeholder=""
                    onChange={e => setPassword(e.target.value)}
                  />
                </Col>
                <Col sm="12" xs="12" md="12" className="cablevideoimagen-input">
                  {!onLogin ? (
                    <button
                      tabIndex={1}
                      type="submit"
                      id="submmit"
                      className="enter-cablevideoimagen"
                      disabled={!props.turnstileSuccess}
                    >
                      {translate("ButtonEnter")}
                    </button>
                  ) : (
                    <Progress animated color="danger" value={100} />
                  )}
                </Col>

              </Row>
              <div className="messages-container">
                <Alert
                  color="danger"
                  id="error-message"
                  isOpen={error.open}
                  toggle={() => setError({ open: false })}
                >
                  {error.message}
                </Alert>
              </div>
              <Row>
                <Col style={{padding:'0'}}>
                  <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
                </Col>
              </Row>
            </Container>
          </Form>
          <div className="logo-costad-div"><img src={aside} alt="aside" className="logo-costado"/></div>
        </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { useInsideForm: true, style: { marginTop: '2rem' } });
